define('v3/Pages/SchoolReport/Components/ClassGrowthInfoBlock/ClassGrowthInfoBlock.Component',[
	'knockout',
	'v3/Common/Models/enums',
	'text!v3/Pages/SchoolReport/Components/ClassGrowthInfoBlock/ClassGrowthInfoBlock.Component.html'
], function (ko, enums, html) {
	function ClassGrowthInfoBlockViewModel (params) {
		var self = this;
		var noData = { name: '', css: 'no-data', description: Strings.NoInformation };
		var unknown = { name: '', css: 'growth-unknown', description: Strings.NoGrowthFound };
		var farBetter = { name: 'GrowthFarAboveAverage', css: 'growth-far-above-average', description: Strings.PercentileLabelFarAbove };
		var better = { name: 'GrowthAboveAverage', css: 'growth-above-average', description: Strings.PercentileLabelAbove };
		var equal = { name: 'GrowthAverage', css: 'growth-average', description: Strings.PercentileLabelAverage };
		var worse = { name: 'GrowthBelowAverage', css: 'growth-below-average', description: Strings.PercentileLabelBelow };
		var farWorse = { name: 'GrowthFarBelowAverage', css: 'growth-far-below-average', description: Strings.PercentileLabelFarBelow };

		var getGrowthCategory = function (growthDetails) {
			if (!growthDetails) {
				return noData;
			}

			if (growthDetails === noData) {
				return noData;
			}

			if (growthDetails.classSubjectGrowthCalculationError === enums.classSubjectGrowthCalculationError.noPupilsInAGradeWithBoundaries ||
				growthDetails.classSubjectGrowthCalculationError === enums.classSubjectGrowthCalculationError.noClassGrowthBoundaries) {
				return noData;
			}

			switch (growthDetails.score) {
			case 0:
				return unknown;
			case 1:
				return farWorse;
			case 2:
				return worse;
			case 3:
				return equal;
			case 4:
				return better;
			case 5:
				return farBetter;
			}
		};

		self.growthDetails = ko.computed(function () {
			return ko.unwrap(params.growthDetails) || noData;
		});

		self.growthClass = ko.computed(function () {
			return getGrowthCategory(self.growthDetails()).css;
		});

		self.growthIcon = ko.computed(function () {
			return getGrowthCategory(self.growthDetails()).name;
		});

		self.growthDescription = ko.computed(function () {
			var growthDetails = self.growthDetails();
			var growthCategory = getGrowthCategory(growthDetails);
			var result = growthCategory.description;

			if (growthCategory !== noData && growthCategory !== unknown) {
				return '<span>' + result + '</span> (' + growthDetails.percentile + '%)';
			}

			return '<span>' + result + '</span>';
		});
	}

	return { viewModel: ClassGrowthInfoBlockViewModel, template: html };
});
